module.exports = __webpack_public_path__ + "img/destination_jozani2.6d535645.jpg";